import { useContext } from 'react'

import {
  MeetingTranscriptContext,
  MeetingTranscriptContextState,
} from 'modules/meetings/lib/context/MeetingTranscriptContext'

export const useMeetingTranscript = (): MeetingTranscriptContextState => {
  const context = useContext(MeetingTranscriptContext)

  if (context === undefined) {
    throw new Error('useMeetingTranscript must be used within a MeetingTranscriptProvider')
  }

  return context
}
